const Menu = [
  {
    name: 'WorkStation',
    path: 'workstation',
    icon: 'fas fa-industry',
    translate: 'sidebar.nav.WorkStation',
    allowedRoles: ['workstation', 'admin', 'superuser'],
    order: 0,
    hasActivities: true,
    subMenuPath: 'overview',
    subMenu: [
      {
        name: 'Overview',
        path: 'overview',
        icon: 'fas fa-grip-horizontal',
        translate: 'sidebar.nav.PLANNING.overview',
      },
    ],
  },
  {
    name: 'Real Time',
    path: 'real-time',
    icon: 'fas fa-desktop',
    translate: 'sidebar.nav.REAL-TIME',
    allowedRoles: ['realtimetracking', 'admin', 'superuser'],
    order: 1,
  },
  {
    name: 'Planning',
    path: 'planning',
    icon: 'far fa-calendar-alt',
    translate: 'sidebar.nav.PLANNING.PLANNING',
    allowedRoles: ['planning', 'admin', 'superuser'],
    order: 2,
    hasActivities: true,
    subMenuPath: 'overview',
    subMenu: [
      {
        name: 'Overview',
        path: 'overview',
        icon: 'fas fa-grip-horizontal',
        translate: 'sidebar.nav.PLANNING.overview',
      },
    ],
  },
  {
    name: 'Dashboard',
    path: 'dashboard',
    icon: 'fa fa-chart-line',
    translate: 'sidebar.nav.DASHBOARD.DASHBOARD',
    order: 3,
    subMenu: [
      {
        name: 'Work Order',
        path: 'work-order',
        icon: 'fas fa-clipboard-list',
        translate: 'sidebar.nav.DASHBOARD.workOrder',
        allowedRoles: ['realtimetracking', 'planning', 'admin', 'superuser', 'quality', 'logistic'],
      },
      {
        name: 'Analytics',
        path: 'analytics',
        icon: 'fas fa-chart-pie',
        translate: 'sidebar.nav.DASHBOARD.analytics',
        isNew: true,
        allowedRoles: ['realtimetracking', 'planning', 'admin', 'superuser'],
      },
      {
        name: 'Stoppage Pareto',
        path: 'stoppages',
        icon: 'fas fa-stopwatch',
        translate: 'sidebar.nav.DASHBOARD.stoppages',
        isNew: true,
        allowedRoles: ['realtimetracking', 'planning', 'manufacturing_eng', 'admin', 'superuser'],
      },
      {
        name: 'OEE',
        path: 'oee',
        icon: 'fas fa-tachometer-alt',
        translate: 'sidebar.nav.DASHBOARD.oee',
        isNew: true,
        allowedRoles: ['realtimetracking', 'planning', 'manufacturing_eng', 'admin', 'superuser'],
      },
      {
        name: 'Scrap Pareto',
        path: 'scrap',
        icon: 'fas fa-recycle',
        translate: 'sidebar.nav.DASHBOARD.scrap',
        isNew: true,
        allowedRoles: ['realtimetracking', 'planning', 'manufacturing_eng', 'admin', 'superuser'],
      },
    ],
  },
  {
    name: 'Task Scheduler',
    path: 'tasks',
    icon: 'fas fa-tasks',
    translate: 'sidebar.nav.tasks.TASKS',
    order: 4,
    allowedRoles: ['admin', 'superuser', 'manufacturing_eng', 'quality', 'workstation'],
    subMenu: [
      {
        name: 'Quality Inspection',
        path: 'quality-inspection',
        icon: 'fa fa-flask',
        translate: 'sidebar.nav.tasks.qualityInspection',
        allowedRoles: ['admin', 'superuser', 'quality'],
        subLabel: 'Gerencie suas inspeções de qualidade',
      },
      {
        name: 'Maintenance',
        path: 'maintenance',
        icon: 'fa fa-wrench',
        translate: 'sidebar.nav.tasks.maintenance',
        allowedRoles: ['admin', 'superuser', 'manufacturing_eng'],
        subLabel: 'Gerencie suas manutenções',
      },
      {
        name: 'Materials Supply',
        path: 'materials-supply',
        icon: 'fa fa-dolly',
        translate: 'sidebar.nav.tasks.materialsSupply',
        allowedRoles: ['admin', 'superuser', 'logistic'],
        subLabel: 'Organize o abastecimento de materiais',
      },
      {
        name: 'Material Lots',
        path: 'material-lots',
        icon: 'fa fa-boxes',
        translate: 'sidebar.nav.tasks.materialLots',
        // mesmos perfis do abastecimento de materiais
        allowedRoles: ['admin', 'superuser', 'logistic'],
        subLabel: 'Consulte os lotes em estoque de cada item',
        isNew: true,
      },
    ],
  },
  {
    name: 'Setup',
    path: 'setup',
    icon: 'fas fa-cogs',
    translate: 'sidebar.nav.SETUP.SETUP',
    order: 5,
    allowedRoles: ['manufacturing_eng', 'admin', 'superuser'],
    subMenu: [
      {
        name: 'workstations',
        path: 'workstation',
        icon: 'fas fa-people-carry',
        translate: 'sidebar.nav.SETUP.workStation',
        subLabel: 'Gerencie suas estações de trabalho e turnos',
      },
      {
        name: 'SKUs',
        path: 'production',
        icon: 'fas fa-barcode',
        translate: 'sidebar.nav.SETUP.production',
        subLabel: 'Gerencie seus produtos',
      },
      {
        name: 'Processos e Sequências',
        path: 'processExecution',
        icon: 'fas fa-clipboard-check',
        translate: 'sidebar.nav.SETUP.processExecution',
        subLabel: 'Crie formulários de execução',
      },
      {
        name: 'Production Inspection',
        path: 'production-inspection',
        icon: 'fas fa-wrench',
        translate: 'sidebar.nav.SETUP.productionInspection',
        subLabel: 'Crie tipos de manutenções, inspeções e testes',
      },
      {
        name: 'Employees',
        path: 'employee',
        icon: 'far fa-id-card',
        translate: 'sidebar.nav.SETUP.employee',
        subLabel: 'Gerencie seus colaboradores',
      },
      {
        name: 'Pausas',
        path: 'pauses',
        icon: 'fas fa-pause',
        translate: 'sidebar.nav.SETUP.pauses',
        subLabel: 'Crie pausas específicas para sua produção',
      },
      {
        name: 'Motivos de refugo',
        path: 'scrap-reasons',
        icon: 'fas fa-recycle',
        translate: 'sidebar.nav.SETUP.scrapReasons',
        subLabel: 'Cadastre os motivos de refugo da produção',
      },
      {
        name: 'Etiquetas',
        path: 'tags',
        icon: 'fas fa-print',
        translate: 'sidebar.nav.SETUP.print',
        subLabel: 'Crie etiquetas com sua marca',
      },
      {
        name: 'Hooks',
        path: 'hooks',
        icon: 'fas fa-link',
        translate: 'sidebar.nav.SETUP.hooks',
        subLabel: 'Gerencie webhooks e integrações',
      },
    ],
  },
  {
    name: 'Admin',
    path: 'admin',
    icon: 'fas fa-users-cog',
    translate: 'sidebar.nav.ADMIN.ADMIN',
    allowedRoles: ['superuser'],
    order: 6,
    subMenu: [
      {
        name: 'Users',
        path: 'user',
        icon: 'fas fa-users',
        translate: 'sidebar.nav.ADMIN.user',
      },
    ],
  },
]

export default Menu
